<template>
  <el-container class="app-mian">
    <el-header class="mian-header">
      <logo class="header-logo" :isCollapse.sync='isCollapse' :style="isCollapse?'width: 64px;':'width:200px;'" />
      <Tophurdle class="header-tophurdle" :isCollapse.sync='isCollapse' :imState='imState' :imVisible.sync='imVisible' :unreadCount='unreadCount'></Tophurdle>
      <user class="header-user" />
    </el-header>
    <el-container class="mian-container">
      <sidebar class="container-sidebar" :isCollapse='isCollapse' :style="isCollapse?'':'width:200px;'" />
      <el-main class="container-model">
        <router-view class="homemodel" v-if="$route.name == 'Home'" />
        <template v-else>
          <div class="modelview">
            <Pagetabs :key="$route.name" />
            <keep-alive>
              <router-view class="pagemodel" />
            </keep-alive>
          </div>
        </template>
      </el-main>
    </el-container>
    <!-- <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut"> -->
    <div class="wrapper" ref="wrapper" v-show="imVisible" @click.self="imVisible = false">
      <div class="imContent" v-draggable="draggableValue">
        <div class="head" ref="head">即时通讯</div>
        <iframe id="iframe" name="iframe" ref="iframe" :src="harf" class="iframe"></iframe>
      </div>
    </div>
    <!-- </transition> -->
  </el-container>
</template>

<script>
import Logo from './Logo'
import Tophurdle from './Tophurdle'
import User from './User'
import Sidebar from './Sidebar'
import Pagetabs from './Pagetabs'
import Vue from 'vue'
const target = process.env.VUE_APP_BASE_IM
const standardStamp = process.env.VUE_APP_TIME_STAMP

export default {
  name: 'Layout',
  components: { Logo, Tophurdle, User, Sidebar, Pagetabs },
  data() {
    return {
      isCollapse: false,
      imState: false,
      imVisible: false,
      unreadCount: 0,
      harf: target + '?key=' + Date.now(),
      draggableValue: {
        handle: undefined,
        boundingRect: undefined
      },
    }
  },
  created() {
    let timeStamp = localStorage.getItem('timeStamp')
    if (!timeStamp || timeStamp < standardStamp) {
      localStorage.removeItem('x-auth-token')
      this.$message('系统版本已升级,请重新登录')
    }
  },
  async mounted() {
    this.draggableValue.handle = this.$refs['head'] // 弹窗拖动
    this.draggableValue.boundingElement = this.$refs['wrapper']
    // -----------------------------------
    // 父窗体发送消息事件:this.$refs.iframe.contentWindow.postMessage,子窗体发送消息事件：window.parent.postMessage
    // 父窗体接受消息事件:window.addEventListener('message',funciton),子窗体接受消息事件：window.addEventListener('message',funciton)
    // -----------------------------------
    // 发送消息函数
    window.sendMessage = (fun, data) => {
      // window.frames['iframe'].window.func(wayBillId) 这种发送消息本地环境存在跨域，且不能this.$refs.iframe获取调用子窗体
      this.$refs.iframe.contentWindow.postMessage({ type: 'app', fun, data }, '*')
    }
    // 接收消息
    window.addEventListener('message', (e) => {
      let msg = e.data
      if (msg && msg.type == 'app') {
        window[msg.fun](msg.data)
      }
    })
    // 发送子窗体初始化消息
    this.$refs.iframe.onload = () => {
      let data = { startUrl: target, tenantId: localStorage.getItem('tenantId'), userCode: JSON.parse(localStorage.getItem('userinfo')).userCode, userName: JSON.parse(localStorage.getItem('userinfo')).userName, xAuthToken: localStorage.getItem('x-auth-token') }
      window.sendMessage('init', data)
    }
    // 接受子窗体初始化完毕后登录状态和改变改装
    window.imloadend = (flog) => {
      if (flog) {
        this.imState = true
        document.title = '发货助手'
        let sendMessage = localStorage.getItem('sendMessage')
        if (sendMessage) {
          this.imVisible = true
          let obj = JSON.parse(sendMessage)
          window.sendMessage(obj.k, obj.v)
          localStorage.removeItem('sendMessage')
        }
      } else {
        this.imState = false
        this.imVisible = false
        document.title = '发货助手（离开）'
      }
    }
    // 接受子窗体同步未读消息
    window.unread = (unreadCount) => {
      this.unreadCount = unreadCount
    }
    // 发送子窗体打开运单会话消息
    Vue.prototype.$wechatwayBill = (wayBill, branchUser, contentText) => {
      if (this.imState) {
        this.imVisible = true
        window.sendMessage('wechatwayBill', { wayBill, branchUser, contentText })
      } else {
        this.$confirm('发货助手链接中断，请刷新...', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          center: true
        }).then(() => {
          let sendMessage = JSON.stringify({ k: 'wechatwayBill', v: { wayBill, branchUser, contentText } })
          localStorage.setItem('sendMessage', sendMessage)
          window.location.reload()
        })
      }
    }
    // 发送子窗体打开服务商会话消息
    Vue.prototype.$wechatbranch = (branch, branchUser, contentText) => {
      if (this.imState) {
        this.imVisible = true
        window.sendMessage('wechatbranch', { branch, branchUser, contentText })
      } else {
        this.$confirm('发货助手链接中断，请刷新...', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          center: true
        }).then(() => {
          let sendMessage = JSON.stringify({ k: 'wechatbranch', v: { branch, branchUser, contentText } })
          localStorage.setItem('sendMessage', sendMessage)
          window.location.reload()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-mian {
  height: 100%;
}
.mian-header {
  height: 56px !important;
  line-height: 56px;
  box-shadow: 0 2px 12px #d1d4d7;
  display: flex;
  overflow: hidden;
  padding: 0;
  z-index: 100;
  .header-logo {
    width: 200px;
  }
  .header-tophurdle {
    flex: 1;
  }
  .header-user {
    width: 100px;
  }
}
.mian-container {
  overflow: auto;
  .container-sidebar {
    z-index: 200;
    overflow: auto;
  }
  .container-model {
    flex: 1;
    padding: 0;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: #f5f7fa;
    .homemodel {
      flex: 1;
    }
    .modelview {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
    }
    .pagemodel {
      flex: 1;
      overflow: auto;
      padding: 12px;
    }
  }
}
.wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  .imContent {
    position: relative;
    top: 15%;
    margin: 0 auto;
    width: 1200px;
    height: 678px;
    background: white;
    box-shadow: 0 5px 5px -3px rgb(0 0 0 / 20%), 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%);
  }
  .head {
    width: 100%;
    height: 28px;
    line-height: 28px;
    padding: 0 12px;
    color: gray;
    cursor: move;
    font-size: 10px;
  }
  .iframe {
    width: 100%;
    height: 650px;
    border: 0;
    background: #f5f5f5;
  }
}
</style>